<template>
    <div class="row">
        <div v-for="(clinic, index) in clinics" :key="index" class="col-lg-4 col-md-6 wow move-up">
            <div class="clinic-grid mb-30">
                <div class="ht-clinic-service-box">
                    <router-link to="">
                        <span class="content-header">
                            <div class="icon">
                                <i :class="clinic.icon"></i>
                            </div>
                            <h5 class="heading">{{ $t(clinic.heading) }}</h5>
                        </span>
                        <!-- <div class="content-body">
                            <div class="service_text">{{ clinic.text }}</div>
                        </div> -->
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ClinicFeature',
        data (){
            return {
                clinics: [
                    {
                        icon:'fal fa-users', 
                        heading:'deneyimliuzmanlar',
                        text:'Bakım, destek ve teknik konularda deneyimli uzmanlardan en iyi hizmeti alın.'
                    },
                    {
                        icon:'fal fa-heartbeat', 
                        heading:'zamanindadestek',
                        text:'Bakım, destek ve teknik konularda deneyimli uzmanlardan en iyi hizmeti alın.'
                    },
                    {
                        icon:'fal fa-ambulance', 
                        heading:'uygunfiyatlar',
                        text:'Bakım, destek ve teknik konularda deneyimli uzmanlardan en iyi hizmeti alın.'

                    },
                    {
                        icon:'fal fa-briefcase-medical', 
                        heading:'isgelistirme',
                        text:'Bakım, destek ve teknik konularda deneyimli uzmanlardan en iyi hizmeti alın.'
                    },
                    {
                        icon:'fal fa-bell', 
                        heading:'musteritemsilcisi',
                        text:'Bakım, destek ve teknik konularda deneyimli uzmanlardan en iyi hizmeti alın.'
                    },
                    {
                        icon:'fal fa-suitcase', 
                        heading:'teknikegitim',
                        text:'Bakım, destek ve teknik konularda deneyimli uzmanlardan en iyi hizmeti alın.'
                    },
                ]
            }
        }
    }
</script>
